
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/vender-id/[venderUrlId]",
      function () {
        return require("private-next-pages/article/vender-id/[venderUrlId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/vender-id/[venderUrlId]"])
      });
    }
  